import { useState, useEffect } from 'react';

import AntSettings, { randomOrientation } from './AntSettings';

import { directions, randomDirection } from './RuleSettings';
import { hexToColor } from './Color';
import colorSchemes from './base16';

function App() {
  const [colorScheme, setColorScheme] = useState("Default Light");

  const [settings, setSettings] = useState({
    reset: true,
    running: true,
    speed: 100,
    scale: 4,
    colorScheme: colorSchemes[colorScheme].map(hexToColor),
    ants: [
      {
        startX: 50,
        startY: 50,
        startOrientation: "R",
        rules: [
          {
            direction: "R",
            color: 5,
          },
          {
            direction: "L",
            color: 0,
          },
        ],
      },
    ],
  });

  const [newAntRules, setNewAntRules] = useState('');

  useEffect(() => {
    window.settings = settings;
  }, [settings]);

  return (
    <form>
      <div className="mb-3">
        <button
          type="button" className="btn btn-secondary me-2"
          onClick={() => {
            setSettings({
              ...settings,
              running: !settings.running
            });
          }}
        >
          <i className={"bi bi-" + (settings.running ? "pause" : "play") + "-fill"}></i>
        </button>
        <button
          type="button" className="btn btn-secondary me-4"
          onClick={() => {
            setSettings({
              ...settings,
              reset: true,
              running: false,
            });
          }}
        ><i className="bi bi-stop-fill"></i></button>
        <button
          type="button" className="btn btn-secondary"
          onClick={() => {
            const newColorScheme = Object.keys(colorSchemes)[Math.floor(Math.random() * Object.keys(colorSchemes).length)];
            setSettings({
              ...settings,
              reset: true,
              colorScheme: colorSchemes[newColorScheme].map(hexToColor),
              ants: Array(Math.floor(Math.random() * 10) + 1).fill(0).map(() => ({
                startX: Math.floor(Math.random() * 101),
                startY: Math.floor(Math.random() * 101),
                startOrientation: randomOrientation(),
                rules: Array(Math.floor(Math.random() * 9) + 2).fill(0).map(() => ({
                  direction: randomDirection(),
                  color: Math.floor(Math.random() * 16),
                })),
              })),
            });
            setColorScheme(newColorScheme);
          }}
        > <i className="bi bi-dice-3-fill"></i></button>
      </div>
      <div className="mb-3 row">
        <label htmlFor="speed" className="col-4 col-form-label">Steps / sec</label>
        <div className="col-8">
          <div className="input-group">
            <button
              type="button" className="btn btn-secondary"
              disabled={settings.speed <= 1}
              onClick={() => {
                setSettings({
                  ...settings,
                  speed: Math.max(Math.floor(settings.speed * 0.5), 1),
                });
              }}
            ><i className="bi bi-dash"></i></button>
            <input
              type="text" id="speed" className="form-control" min="1"
              step={settings.speed}
              value={settings.speed}
              onChange={e => {
                const value = e.target.value ? parseInt(e.target.value, 10) : 1;
                if (value >= 1) {
                  e.target.step = value;
                  setSettings({
                    ...settings,
                    speed: value,
                  });
                }
              }}
            />
            <button
              type="button" className="btn btn-secondary"
              onClick={() => {
                setSettings({
                  ...settings,
                  speed: Math.floor(settings.speed * 2),
                });
              }}
            ><i className="bi bi-plus"></i></button>
          </div>
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="Scale" className="col-4 col-form-label">Square size</label>
        <div className="col-8">
          <div className="input-group">
            <button
              type="button" className="btn btn-secondary"
              disabled={settings.scale <= 1}
              onClick={() => {
                setSettings({
                  ...settings,
                  reset: true,
                  scale: Math.max(Math.floor(settings.scale * 0.5), 1),
                });
              }}
            ><i className="bi bi-dash"></i></button>
            <input
              type="text" id="scale" className="form-control" min="1"
              value={settings.scale}
              onChange={e => {
                const value = e.target.value ? parseInt(e.target.value, 10) : 1;
                if (value >= 1) {
                  setSettings({
                    ...settings,
                    reset: true,
                    scale: value,
                  });
                }
              }}
            />
            <button
              type="button" className="btn btn-secondary"
              onClick={() => {
                setSettings({
                  ...settings,
                  reset: true,
                  scale: Math.floor(settings.scale * 2),
                });
              }}
            ><i className="bi bi-plus"></i></button>
          </div>
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="scheme" className="col-4 col-form-label"><a href="https://github.com/chriskempson/base16#scheme-repositories" target="_blank" rel="noreferrer">Color scheme</a></label>
        <div className="col-8">
          <div className="input-group">
            <button
              type="button" className="btn btn-secondary"
              onClick={() => {
                const newColorScheme = Object.keys(colorSchemes)[Math.floor(Math.random() * Object.keys(colorSchemes).length)];
                setSettings({
                  ...settings,
                  reset: true,
                  colorScheme: colorSchemes[newColorScheme].map(hexToColor),
                });
                setColorScheme(newColorScheme);
              }}
            > <i className="bi bi-dice-3-fill"></i></button>
            <select
              className="form-select"
              value={colorScheme}
              onChange={e => {
                setSettings({
                  ...settings,
                  reset: true,
                  colorScheme: colorSchemes[e.target.value].map(hexToColor),
                });
                setColorScheme(e.target.value);
              }}
            >
              {Object.keys(colorSchemes).sort().map(key => (
                <option key={key} value={key}>{key}</option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <div className="mb-3">
        <label htmlFor="ants" className="form-label">Ants</label>
        <div className="input-group mb-3">
          <button
            type="button" className="btn btn-secondary"
            onClick={() => {
              setNewAntRules(Array(Math.floor(Math.random() * 8) + 3).fill(0).map(() => randomDirection()).join(''));
              document.getElementById('new_ant_rules').focus();
            }}
          > <i className="bi bi-dice-3-fill"></i></button>
          <input
            type="text" className="form-control" placeholder="Rules (RLNU)" id="new_ant_rules"
            value={newAntRules}
            onChange={e => setNewAntRules(e.target.value.toUpperCase().split('').filter(c => Object.keys(directions).includes(c)).join(''))}
            onKeyDown={e => {
              if (e.key === 'Enter') {
                document.getElementById('new_ant').click();
              }
            }}
          />
          <button
            type="button" className="btn btn-primary" id="new_ant"
            onClick={() => {
              setSettings({
                ...settings,
                reset: true,
                ants: [
                  ...settings.ants,
                  {
                    startX: 25 + Math.floor(Math.random() * 51),
                    startY: 25 + Math.floor(Math.random() * 51),
                    startOrientation: randomOrientation(),
                    rules: newAntRules.split("").map(rule => ({
                      direction: rule,
                      color: Math.floor(Math.random() * 16),
                    })),
                  },
                ],
              });
              setNewAntRules("");
            }}
          >
            Add
          </button>
        </div>
        <div className="accordion" id="ants">
          {settings.ants.map((_, antIndex) => (
            <AntSettings key={antIndex} settings={settings} setSettings={setSettings} antIndex={antIndex} />
          ))}
        </div>
      </div>
    </form >
  );
}

export default App;
